import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { concat, Observable, of } from 'rxjs';
import { from } from 'rxjs/internal/observable/from';
import * as overview from './overview.actions';
import { OverviewData, OverviewDataRequest } from './overview.models';
import { HttpService } from '../../global/http.service';

import { Actions as ActionsCDK } from "atlas-cdk";
import { ToastService } from '../../shared/toaster_/toaster_.service';

@Injectable()
export class OverviewEffects {
  public loadTransactions$ = createEffect(() => this.actions$.pipe(
    ofType<overview.LoadWidgetsDataAction>(overview.ActionTypes.LOAD_WIDGETS_DATA),
    map(action => action.payload),
    switchMap(payload =>
      this.loadWidgetsData(payload).pipe(
        map((response: OverviewData) =>
          new overview.LoadWidgetsDataSuccessAction(response)
        ),
        catchError(error =>
          // from([
          //   new overview.LoadWidgetsDataFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new overview.LoadWidgetsDataFailedAction(error));
          // }
          concat(
            of(new overview.LoadWidgetsDataFailedAction(error)),
            of(null).pipe(
              tap(() => {
                const errorMessage = (error?.error != null && error.error.message != null)
                  ? error.error.message
                  : error.message;
                this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  public constructor(private readonly actions$: Actions, private readonly http: HttpService, private readonly _toasterService: ToastService) {
  }

  private loadWidgetsData(payload: OverviewDataRequest): Observable<OverviewData> {
    return this.http.post(`/widgets/overview`, { account: payload.account, country: payload.country });
  }
}
